/* eslint-disable no-unused-vars */
import { useEffect, useId } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { authAPI } from 'services/newPlatformAuth.service';
import { Loader, CustomInput, Buttons } from 'components';
import { GridBackground } from '../userLogin/GridBackground';
import { ForgotPasswordSuccess } from './ForgotPasswordSuccess';
import { showPolipop } from 'utils';
import * as S from './ForgotPassword.styled';

export const ForgotPassword = () => {
  const {
    handleSubmit,
    getValues,
    control,
    trigger,
    clearErrors,
    formState: { errors, isValid, isSubmitting, isSubmitSuccessful },
  } = useForm();
  const navigate = useNavigate();
  const formId = useId();
  const emailId = useId();
  const [userForgotPasswordAction, result] = authAPI.useUserForgotPasswordMutation();

  const onSubmit = (data) => {
    userForgotPasswordAction(data);
  };

  const onCancel = () => {
    navigate('/userLogin');
  };

  useEffect(() => {
    if (result.isError) {
      showPolipop(result);
    }
  }, [result]);

  if (
    isSubmitSuccessful &&
    !result.isError &&
    !result.isLoading &&
    result.status !== 'uninitialized'
  )
    return (
      <S.Box>
        <GridBackground />
        <ForgotPasswordSuccess data={getValues()} />
      </S.Box>
    );

  return (
    <S.Box>
      <GridBackground />
      {(isSubmitting || result.isLoading) && (
        <S.LoaderBox>
          <Loader.Local delay={100} />
        </S.LoaderBox>
      )}
      <S.StyledForm id={formId} onSubmit={handleSubmit(onSubmit)}>
        <S.Title>Forgot Password</S.Title>
        <S.Paragraph>
          Submit your email address to reset the password. Follow the link in the email to choose
          the new password
        </S.Paragraph>
        <Controller
          name='email'
          control={control}
          rules={{
            required: 'Email is required',
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: 'Please enter a valid email address',
            },
          }}
          render={(props) => {
            const { field } = props;
            return (
              <S.InputGroup>
                <S.InputLabel htmlFor={emailId}>Email:</S.InputLabel>
                <S.InputWrapper error={Boolean(errors.email)}>
                  <S.StyledInput
                    id={emailId}
                    placeholder='Enter your email'
                    name={field.name}
                    value={field.value || ''}
                    onChange={field.onChange}
                    onFocus={() => {
                      clearErrors('email');
                    }}
                    onBlur={() => {
                      field.onBlur();
                      trigger('email');
                    }}
                  />
                </S.InputWrapper>
                {errors?.email && <S.ErrorText>{errors.email.message}</S.ErrorText>}
              </S.InputGroup>
            );
          }}
        />
        <S.BtnBox>
          <S.CancelButton type='button' onClick={onCancel}>
            Cancel
          </S.CancelButton>
          <S.SendButton type='submit' disabled={!isValid || isSubmitting || result.isLoading}>
            Send
          </S.SendButton>
        </S.BtnBox>
      </S.StyledForm>
    </S.Box>
  );
};
